import { textFilter } from "react-bootstrap-table2-filter";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
} from "../../core/Helper";

export const SearchBank = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "bankid";
  const displayFieldName = "bankshort";

  setSearchB({
    autoFirstPage: true,
    title: "ธนาคาร",
    size: "sm",
    show: true,
    fieldId: idFieldName,
    fieldName: "bankname",
    sql: {
      fields: ["bankid", "bankshort"],
      tableName: "sy_bank a ",
      defaultCriteria: ` a.del_flag ='n'`,
      criteriaFields: ["a.bankshort"],
      criteriaText: "",
      orderBy: ["a.bankshort"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "bankshort",
        text: "เลือกธนาคาร",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};
